import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features9.css'

const Features9 = (props) => {
  return (
    <div className="features9-layout186 thq-section-padding">
      <div className="thq-flex-column thq-section-max-width">
        <h2 className="features9-text10 thq-heading-2">
          {props.feature1Title ?? (
            <Fragment>
              <span className="features9-text13">Follow Us</span>
            </Fragment>
          )}
        </h2>
        <div className="features9-container1">
          <div className="features9-container2">
            <a
              href="https://www.linkedin.com/company/sydrisworx/posts/?feedView=all"
              target="_blank"
              rel="noreferrer noopener"
              className="features9-link1"
            >
              <img
                alt={props.imageAlt3}
                src={props.imageSrc3}
                className="features9-image"
              />
            </a>
          </div>
          <div className="features9-container3">
            <span className="features9-text11">
              {props.text ?? (
                <Fragment>
                  <span className="features9-text19">Sydrisworx</span>
                </Fragment>
              )}
            </span>
            <span className="features9-text12">
              {props.text1 ?? (
                <Fragment>
                  <span className="features9-text14">
                    <span>Bridge the data &amp; digital gap!</span>
                    <br></br>
                    <span>IT Services and IT Consulting</span>
                  </span>
                </Fragment>
              )}
            </span>
            <a
              href="mailto:Letswork@Sydrisworx.co.za?subject="
              className="features9-link2"
            >
              {props.text11 ?? (
                <Fragment>
                  <span className="features9-text18">
                    Letswork@Sydrisworx.co.za
                  </span>
                </Fragment>
              )}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

Features9.defaultProps = {
  imageAlt3: 'image',
  feature1Title: undefined,
  imageSrc3: '/linkedin%20logo-200h.png',
  text1: undefined,
  text11: undefined,
  text: undefined,
}

Features9.propTypes = {
  imageAlt3: PropTypes.string,
  feature1Title: PropTypes.element,
  imageSrc3: PropTypes.string,
  text1: PropTypes.element,
  text11: PropTypes.element,
  text: PropTypes.element,
}

export default Features9
